import { useState } from "react";
import InquiryFormModal from "../../common_components/InquiryFormModal/InquiryFormModal";
import "./TalkToCounsellor.css";

const TalkToCounsellor = () => {
  const [modalshow, setmodalshow] = useState(false);
  const openModal = () => {
    setmodalshow(true);
    // setExpanded(false);
  };

  return (
    <section className="final-cta">
      <div className="wrap">
        <span className="eyebrow">Ready When You Are</span>

        <h2>Talk to a counsellor before you decide</h2>

        <p>
          Get a personalized comparison of universities, fees and
          specializations — free, no obligation.
        </p>

        <div className="final-cta-actions">
          <div className="btn btn-gold" onClick={openModal}>
            Get Free Counselling
          </div>

          <a
            href="https://api.whatsapp.com/send?phone=918956353503&text=%20"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline"
          >
            <span className="whatsapp-icon">◉</span>
            Chat on WhatsApp
          </a>
        </div>
      </div>

      <InquiryFormModal
        show={modalshow}
        onHide={() => {
          setmodalshow(false);
          // setExpanded(false);
        }}
        setmodalshow={setmodalshow}
        modalshow={modalshow}
      />
    </section>
  );
};

export default TalkToCounsellor;
